export var handleOnKeyDown = function (e, cb) {
    if (e.key === 'Enter') {
        cb();
    }
};
